"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3987],{

/***/ 3987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Recommendations; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-d6406817.mjs
var Image_d6406817 = __webpack_require__(5905);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/swiper.min-13551361.mjs
var swiper_min_13551361 = __webpack_require__(5038);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-c598cb52.mjs
var Button_c598cb52 = __webpack_require__(7977);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Recommendations.js












const y = "card", A = "card__title", M = "card__image-container", R = "card--pressed", W = "desktop", G = "card__save-button", H = "card__info", z = "card__date", $ = "card__description", F = "card__description--hidden", r = {
  card: y,
  cardTitle: A,
  cardImageContainer: M,
  cardPressed: R,
  desktop: W,
  cardSaveButton: G,
  cardInfo: H,
  cardDate: z,
  cardDescription: $,
  cardDescriptionHidden: F
}, P = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric"
}, X = ({
  title: d,
  description: a,
  date: i,
  dateEnd: g,
  link: h,
  image: s = null,
  linkLocale: f,
  i18n: c = {}
}) => {
  const { date: m = "Date", startFrom: E = "Start from" } = c, [v, e] = (0,react.useState)(!1), n = i?.toLocaleDateString("fi", P), N = g?.toLocaleDateString("fi", P), b = !N || N === n ? m : E;
  return /* @__PURE__ */ react.createElement(
    Link_479ac100.L,
    {
      "data-testid": "card",
      href: h,
      locale: f,
      disableLinkTextStyle: !0,
      className: (0,app_a75c1d35.c)(r.card, v && r.cardPressed),
      onMouseDown: () => e(!0),
      onMouseUp: () => e(!1),
      onMouseLeave: () => e(!1)
    },
    /* @__PURE__ */ react.createElement(
      "div",
      {
        className: (0,app_a75c1d35.c)(r.cardImageContainer),
        "data-testid": "card-image",
        itemScope: !0,
        itemType: "https://schema.org/ImageObject"
      },
      s && /* @__PURE__ */ react.createElement(
        Image_d6406817.I,
        {
          credits: s.credits,
          src: s.src,
          width: s.width,
          height: s.height,
          altText: s.altText,
          imageLoader: s.imageLoader,
          styling: s.styling
        }
      )
    ),
    /* @__PURE__ */ react.createElement("div", { className: (0,app_a75c1d35.c)(r.cardInfo), "data-testid": "card-content" }, i && /* @__PURE__ */ react.createElement("p", { className: (0,app_a75c1d35.c)(r.cardDate, app_a75c1d35.t.textsLeadText) }, /* @__PURE__ */ react.createElement("meta", { itemProp: "datePublished", content: i.toISOString() }), `${b} ${n}`), /* @__PURE__ */ react.createElement("div", { className: r.cardTitle }, /* @__PURE__ */ react.createElement("p", { className: app_a75c1d35.t.textsComponentTitleBold, itemProp: "name" }, d)), /* @__PURE__ */ react.createElement(
      "p",
      {
        className: (0,app_a75c1d35.c)(r.cardDescription, app_a75c1d35.t.textsLeadText),
        itemProp: "description"
      },
      a
    ))
  );
}, j = "recommendations", U = "recommendations__slide", V = "desktop", q = "recommendations__block", J = "recommendations__header", K = "recommendations__title", Q = "recommendations__navigation", Y = "recommendations__separator", Z = "recommendations__contents", l = {
  recommendations: j,
  recommendationsSlide: U,
  desktop: V,
  recommendationsBlock: q,
  recommendationsHeader: J,
  recommendationsTitle: K,
  recommendationsNavigation: Q,
  recommendationsSeparator: Y,
  recommendationsContents: Z
}, ee = 1216;
function ge({ title: d, cards: a }) {
  const i = (0,react.useRef)(null), [g, h] = (0,react.useState)(!0), [s, f] = (0,react.useState)(!1), c = (0,react.useSyncExternalStore)(
    te,
    ne,
    () => 0
  ), m = (0,react.useMemo)(() => c > app_a75c1d35.D.xl, [c]);
  (0,react.useEffect)(() => {
    const e = i.current;
    if (m && e) {
      const n = (c - ee) / 2;
      e.params.slidesOffsetBefore = n, e.params.slidesOffsetAfter = n, e.update();
    }
    e && a && (e.slideTo(0), f(!e.allowSlideNext || e.isEnd));
  }, [a, c, m]);
  const E = (0,react.useCallback)(
    (e) => {
      if (h(e.isBeginning), m && a) {
        const n = a.length % 3 === 0 ? 3 : 2;
        f(
          e.snapIndex >= Math.trunc(a.length / n) - 1 || e.isEnd
        );
      } else
        f(e.isEnd);
    },
    [a, m]
  ), v = (e) => {
    const n = i.current;
    n && (e === "previous" ? n?.slidePrev() : n?.slideNext());
  };
  return /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      "data-testid": "recommendations-block",
      topPadding: Block_9b78bd10.B.Padding.SMALL,
      bottomPadding: Block_9b78bd10.B.Padding.LARGE
    },
    /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { "data-testid": "recommendations-content" }, /* @__PURE__ */ react.createElement(
      "div",
      {
        className: (0,app_a75c1d35.c)(l.recommendationsHeader),
        "data-testid": "recommendations-header"
      },
      /* @__PURE__ */ react.createElement(
        "p",
        {
          className: (0,app_a75c1d35.c)(
            l.recommendationsTitle,
            app_a75c1d35.t.headingSection
          )
        },
        d
      ),
      !s || !g ? /* @__PURE__ */ react.createElement(
        "div",
        {
          className: (0,app_a75c1d35.c)(l.recommendationsNavigation),
          "data-testid": "recommendations-navigation-container"
        },
        /* @__PURE__ */ react.createElement(
          Button_c598cb52.B.Arrow,
          {
            disabled: g,
            arrowDirection: "left",
            "aria-label": "Previous slide",
            onClick: () => v("previous"),
            "data-testid": "prev"
          }
        ),
        /* @__PURE__ */ react.createElement("div", { className: (0,app_a75c1d35.c)(l.recommendationsSeparator) }),
        /* @__PURE__ */ react.createElement(
          Button_c598cb52.B.Arrow,
          {
            disabled: s,
            arrowDirection: "right",
            "aria-label": "Next slide",
            onClick: () => v("next"),
            "data-testid": "next"
          }
        )
      ) : null
    )),
    a && /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { limitedWidth: !1 }, /* @__PURE__ */ react.createElement(
      "div",
      {
        className: (0,app_a75c1d35.c)(l.recommendations),
        "data-testid": "recommendations-container"
      },
      /* @__PURE__ */ react.createElement(
        swiper_min_13551361.S,
        {
          slidesPerView: "auto",
          spaceBetween: 20,
          slidesPerGroup: 1,
          centeredSlides: !1,
          speed: 500,
          preventClicks: !1,
          preventClicksPropagation: !1,
          touchStartPreventDefault: !1,
          slidesOffsetAfter: 20,
          slidesOffsetBefore: 20,
          onSlideChange: E,
          onSwiper: (e) => {
            i.current = e;
          },
          breakpoints: {
            [app_a75c1d35.D.sm]: {
              slidesPerGroup: 2,
              spaceBetween: 20,
              slidesOffsetBefore: 64,
              slidesOffsetAfter: 64
            },
            [app_a75c1d35.D.md]: {
              slidesPerGroup: 2,
              spaceBetween: 24,
              slidesOffsetBefore: 64,
              slidesOffsetAfter: 64
            },
            [app_a75c1d35.D.lg]: {
              slidesPerGroup: 3,
              spaceBetween: 32,
              slidesOffsetBefore: 80,
              slidesOffsetAfter: 80
            },
            [app_a75c1d35.D.xl]: {
              slidesPerGroup: a.length < 6 ? a.length === 5 ? 2 : 1 : 3,
              spaceBetween: 32,
              slidesOffsetBefore: 112,
              slidesOffsetAfter: 112
            }
          }
        },
        a.map((e, n) => /* @__PURE__ */ react.createElement(
          swiper_min_13551361.a,
          {
            key: n,
            className: l.recommendationsSlide,
            "data-testid": "recommendation"
          },
          /* @__PURE__ */ react.createElement(X, { ...e })
        ))
      )
    ))
  );
}
function te(d) {
  return window.addEventListener("resize", d), () => window.removeEventListener("resize", d);
}
function ne() {
  return window.innerWidth;
}

//# sourceMappingURL=Recommendations.js.map

// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(9800);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/Recommendations/Recommendations.tsx











function Recommendations(param) {
    var title = param.title, matchingNodes = param.matchingNodes;
    var mapNodeToCardProps = useMapNodeToRecommendationCardProps();
    var cards = (0,react.useMemo)(function() {
        return matchingNodes.map(mapNodeToCardProps);
    }, [
        matchingNodes,
        mapNodeToCardProps
    ]).sort(function(a, b) {
        return a.date && b.date ? a.date.getTime() - b.date.getTime() : 0;
    });
    if (cards.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ge, {
        cards: cards,
        title: title
    });
}
function useMapNodeToRecommendationCardProps() {
    var isPreview = (0,router.useRouter)().isPreview;
    var t = (0,esm/* useTranslation */.$G)().t;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    return (0,react.useCallback)(function(node) {
        var ref, ref1;
        var id = node["@id"];
        var date = node.eventDateStart ? new Date(node.eventDateStart) : undefined;
        var dateEnd = node.eventDateEnd ? new Date(node.eventDateEnd) : undefined;
        var imageData = imageDataHandler(node === null || node === void 0 ? void 0 : node.introductionImage, {
            maxViewport: app/* Viewport.xs */.l_.xs
        });
        var image = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
            altText: node.title,
            styling: Image_d6406817.a.CARD,
            credits: (ref = node.introductionImage) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.rights
        });
        return {
            id: id,
            title: node.title,
            description: node.description,
            image: image,
            date: date,
            dateEnd: dateEnd,
            link: (0,magnolia/* formatPageLink */.Jd)(node["@path"], isPreview),
            i18n: {
                date: t("dates.date"),
                startFrom: t("dates.startFrom")
            }
        };
    }, [
        imageDataHandler,
        isPreview,
        t
    ]);
}

;// CONCATENATED MODULE: ./src/magnolia/components/Recommendations/index.ts
/* istanbul ignore file */ 


/***/ })

}]);